import axios from "axios";
import api from "../utils/axiosInterceptor";
const API_URL = process.env.REACT_APP_API_URL;
export const addressAndRatingDetails = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin-rating`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in addressAndRatingDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const editAddressAndRating = async (data) => {
	try {
		const response = await api.put(`${API_URL}/api/admin-rating/edit/${data.id}`, data, {});
		return response.data;
	} catch (error) {
		console.error("Error in editAddressAndRating function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const deleteAddressAndRating = async (id) => {
	try {
		const response = await api.delete(`${API_URL}/api/admin-rating/${id}`, {});
		return response.data;
	} catch (error) {
		console.error("Error in deleteAddressAndRating function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const flagAddressAndRating = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/admin-flag-rating`, data, {});
		return response.data;
	} catch (error) {
		console.error("Error in flagAddressAndRating function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const addressCommentDetails = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin-street-zip-comment`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in addressAndRatingDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const editAddressStreetZip = async (data) => {
	try {
		const response = await api.put(`${API_URL}/api/admin-street-zip-comment/${data.id}`, data, {});
		return response.data;
	} catch (error) {
		console.error("Error in editAddressAndRating function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const deleteAddressStreetZip = async (id) => {
	try {
		const response = await api.delete(`${API_URL}/api/admin-street-zip-comment/${id}`, {});
		return response.data;
	} catch (error) {
		console.error("Error in deleteAddressAndRating function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const flagAddressStreetZip = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/admin-flag-street-zip-comment`, data, {});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const getUserList = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/users/search`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const addressAddressDetails = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin-address`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in addressAndRatingDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const flagAddress = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/admin-flag-address`, data, {});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const deleteAddress = async (id) => {
	try {
		const response = await api.delete(`${API_URL}/api/admin-address/${id}`, {});
		return response.data;
	} catch (error) {
		console.error("Error in deleteAddressAndRating function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const getAdminDashboardService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/dashboard`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const getAdminListController = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/list`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const ModifyAdminDashboard = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/admin/modify`, data, {});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const ChangeUserStatus = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/status`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const DeleteUsers = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/delete`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const getDeleteUserList = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/delete/user/list`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in addressAndRatingDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const ReActiveUsers = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/reactive`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const getAdminContractorListController = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/contractor-list`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const ModifyAdminDashboardContractor = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/admin/modify-contractor`, data, {});
		return response.data;
	} catch (error) {
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const flagContractor = async (data) => {
	try {
		const response = await api.post(`${API_URL}/api/admin-flag-contractor`, data, {});
		return response.data;
	} catch (error) {
		console.error("Error in flagContractor function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const getNotificationsList = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/notification`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in flagContractor function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const deleteNotification = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/notification/delete`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in flagContractor function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const readNotification = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/notification/read`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in flagContractor function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const getAllSubmittedForms = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/feedback`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in getAllSubmittedForms function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const getFormDetails = async (formId, formType) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/forms/${formId}`, {
			params: {formType},
		});
		return response.data;
	} catch (error) {
		console.error("Error in getFormDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const updateFormStatus = async (formId, formType, status) => {
	try {
		const response = await api.put(
			`${API_URL}/api/admin/feedback/${formId}/status`,
			{
				formType,
				status,
			},
			{}
		);
		return response.data;
	} catch (error) {
		console.error("Error in updateFormStatus function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};
export const deleteFeedback = async (id) => {
	try {
		const response = await api.delete(`${API_URL}/api/admin/feedback/${id}`, {});
		return response.data;
	} catch (error) {
		console.error("Error in deleteFeedback function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const loginHistoryDetails = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin-login-history`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in loginHistoryDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const ActivityLogDetails = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin-activity-log`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in ActivityLogDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

// Contact Us Services
export const submitContactUs = async (data) => {
	try {
		const response = await axios.post(`${API_URL}/api/contact-us`, data, {});
		return response.data;
	} catch (error) {
		console.error("Error in submitContactUs function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const getAllContactUs = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/admin/contact-us`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in getAllContactUs function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const updateContactUsStatus = async (contactUsId, statusData) => {
	try {
		const response = await api.put(`${API_URL}/api/admin/contact-us/${contactUsId}/status`, statusData, {});
		return response.data;
	} catch (error) {
		console.error("Error in updateContactUsStatus function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const deleteContactUs = async (id) => {
	try {
		const response = await api.delete(`${API_URL}/api/admin/contact-us/${id}`, {});
		return response.data;
	} catch (error) {
		console.error("Error in deleteContactUs function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const NotificationCountService = async () => {
	try {
		const response = await api.get(`${API_URL}/api/notification/count`, {});
		return response.data;
	} catch (error) {
		console.error("Error in ActivityLogDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};

export const CommentRepliesService = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/comment/replies/list`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in ActivityLogDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};


export const GetReplies = async (data) => {
	try {
		const response = await api.get(`${API_URL}/api/contractor/replies/get`, {
			params: data,
		});
		return response.data;
	} catch (error) {
		console.error("Error in ActivityLogDetails function:", error);
		return error.response && error.response.data ? error.response.data : error.message;
	}
};